import PropTypes from 'prop-types';
import { CURRENCIES } from 'shared/constants';

export const propTypes = {
  id: PropTypes.string,
  rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rateUpTo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ratePeriod: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  monthlyRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  monthlyRateUpTo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currency: PropTypes.oneOf(CURRENCIES),
  // job
  minAllocation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minAllocationPeriod: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // user
  maxAllocation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxAllocationPeriod: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export const defaultProps = {};

export default { defaultProps, propTypes };
